import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../context/LanguageContext';
import { authService } from '../services/api';
import { useSiteConfig } from '../context/SiteConfigContext';
import '../styles/Footer.css';

const defaultDiscord = 'https://discord.gg/ps9smnSu9j';
const defaultSupportTicket = 'https://discord.com/channels/1463913142328234223/1464036874992488603';

const Footer: React.FC = () => {
    const { t } = useLanguage();
    const { config } = useSiteConfig();
    const discordUrl = config.links?.discord || defaultDiscord;
    const supportTicketUrl = config.links?.supportTicket || defaultSupportTicket;
    const year = new Date().getFullYear();
    const isAuthenticated = authService.isAuthenticated();
    return (
        <footer className="footer">
            <div className="container">
                <div className="footer-content">
                    <div className="footer-column">
                        <h4>{t('footer.links')}</h4>
                        <ul>
                            <li><Link to="/rankings">{t('footer.rankings')}</Link></li>
                            <li><Link to="/news">{t('footer.news')}</Link></li>
                            <li><Link to="/classes">{t('footer.guide')}</Link></li>
                            <li><Link to="/download">{t('footer.support')}</Link></li>
                            <li><Link to="/usercp">{t('footer.kvkk')}</Link></li>
                        </ul>
                    </div>
                    <div className="footer-column">
                        <h4>{t('footer.newsAndAnnouncements')}</h4>
                        <ul>
                            <li><Link to="/news">{t('footer.patchNotes')}</Link></li>
                            <li><Link to="/news">{t('footer.developments')}</Link></li>
                            <li><Link to="/news">{t('footer.events')}</Link></li>
                            <li><Link to="/news">{t('footer.announcements')}</Link></li>
                        </ul>
                    </div>
                    <div className="footer-column">
                        <h4>{t('footer.memberProcedures')}</h4>
                        <ul>
                            {!isAuthenticated && (
                                <li><Link to="/register">{t('footer.newMemberRegistration')}</Link></li>
                            )}
                            {!isAuthenticated ? (
                                <li><Link to="/login">{t('footer.signIn')}</Link></li>
                            ) : (
                                <li><Link to="/usercp">{t('nav.myAccount')}</Link></li>
                            )}
                            <li><Link to="/forgot-password">{t('footer.forgotPassword')}</Link></li>
                        </ul>
                    </div>
                    <div className="footer-column">
                        <h4>{t('footer.helpSupport')}</h4>
                        <ul>
                            <li><a href={discordUrl} target="_blank" rel="noopener noreferrer">{t('footer.discordSupport')}</a></li>
                            <li><a href={supportTicketUrl} target="_blank" rel="noopener noreferrer">{t('footer.createSupportTicket')}</a></li>
                        </ul>
                    </div>
                </div>
                <div className="footer-bottom">
                    <p>{t('footer.copyright').replace('{year}', String(year))}</p>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
